/**
 * DEV-1093. Ответы квиза лендинга в карточке клиента: цели покупки, срок
 * решения, доля первоначального взноса и площадка-источник.
 *
 * Overlay-модуль поверх базовых локалей: правка подписи здесь перекрывает ru/en/vn.
 * DEV-2145 привёл четвёрку выбираемых целей и срок «Не определён» к словам задачи;
 * «рост стоимости», «сохранение капитала» и «изучает рынок» остались как в квизе —
 * под ними лиды рекламного контура.
 */
export const quizFieldsMessages = {
  ru: {
    clients: {
      form: { downPaymentPercent: 'Первоначальный взнос' },
      detail: { landingSlug: 'Лендинг' },
      enums: {
        purchaseGoal: {
          living: 'Проживание',
          valueGrowth: 'Рост стоимости',
          capitalPreservation: 'Сохранение капитала',
          combined: 'Проживание и сдача',
          marketResearch: 'Изучает рынок',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 месяца',
          later: 'Позже',
          researching: 'Не определён',
        },
      },
    },
  },
  en: {
    clients: {
      form: { downPaymentPercent: 'Down payment' },
      detail: { landingSlug: 'Landing' },
      enums: {
        purchaseGoal: {
          living: 'Living',
          valueGrowth: 'Value growth',
          capitalPreservation: 'Capital preservation',
          combined: 'Living and renting out',
          marketResearch: 'Exploring the market',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 months',
          later: 'Later',
          researching: 'Not defined',
        },
      },
    },
  },
  vn: {
    clients: {
      form: { downPaymentPercent: 'Thanh toán ban đầu' },
      detail: { landingSlug: 'Trang đích' },
      enums: {
        purchaseGoal: {
          living: 'Để ở',
          valueGrowth: 'Tăng giá trị',
          capitalPreservation: 'Bảo toàn vốn',
          combined: 'Vừa ở vừa cho thuê',
          marketResearch: 'Đang tìm hiểu thị trường',
        },
        dealTimeline: {
          oneToThreeMonths: '1–3 tháng',
          later: 'Muộn hơn',
          researching: 'Chưa xác định',
        },
      },
    },
  },
}
